// NOTE:
// We want dev (CRA), staging, and prod to behave the same regarding
// OAuth redirect URIs and API base URLs.
// - In CRA dev (`npm start`), hostname === 'localhost' and we rely on
//   the CRA proxy (see package.json "proxy"), so API base URL is ''.
// - In built apps served by Django (staging/prod/backend), the origin
//   is the backend domain, so we use that for both API and redirect URI.

const appBaseUrl = window.location.origin;

const APP_CONFIG = {
  baseWebApiUrl:
    window.location.hostname === 'localhost' ? '' : window.location.origin,

  appBaseUrl,
  sessionVariables: {
    AUTH_TOKEN: 'authToken',
    USER_INFO: 'userInfo',
    OPEN_TABS: 'openTabs',
    SELECTED_TAB: 'selectedTab',
  },
  socialLoginClientId: {
    google:
      '849925148578-jk1itbu7822ual12ldg7qu3hlalh04go.apps.googleusercontent.com',
    apple: 'com.ios.cinebudget2',
    facebook: '990461205706658',
  },
  redirectURI: `${appBaseUrl}/auth/login`,
};

export default APP_CONFIG;
